<div class="login-container">
  <div class="login-card">
    <h1 class="login-title">SafeScan</h1>

    <form (ngSubmit)="loginUser()">
      <div class="form-group">
        <div class="input-with-icon">
          <i class="fa fa-user" aria-hidden="true" style="margin-left: 10px;"></i>
          <input
            type="text"
            [(ngModel)]="username"
            name="username"
            placeholder="Username"
          />
        </div>
      </div>

      <div class="form-group">
        <div class="input-with-icon">
          <i class="fa fa-lock" aria-hidden="true" style="margin-left: 10px;"></i>
          <input
            type="password"
            name="password"
            [(ngModel)]="password"
            placeholder="Password"
          />
        </div>
      </div>

      <button type="submit" class="login-button">Login</button>
    </form>
    <hr />
    <p class="support-text">
      If you need any support or are having login issues, please email
      <a href="https://www.safescan.cloud/support" class="support-link"
        >support</a
      >
    </p>
  </div>
</div>
<div class="sidebar-version">
  <p>{{ version }}</p>
</div>
